import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import EditLicensePlateLayout from 'feature/license-plates/edit-license-plate-layout';
import qs from 'query-string';
import {
  useLicensePlateContext,
  INITIALIZE,
  CHANGE_PLATE_NUMBER,
  CHANGE_CAR_TYPE,
  CHANGE_ENERGY_SOURCE_TYPE
} from 'feature/license-plates/use-license-plate';
import amplitude from 'service/amplitude';
import { FUEL_TYPE } from "model/energy-source";

const EditLicensePlate = () => {
  const { state, dispatch, updateLicensePlate, redirectAfterEditPlate } = useLicensePlateContext();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    const id = params.id;
    const plateNumber = qs.parse(location.search).plateNumber;
    const vehicleType = qs.parse(location.search).vehicleType;
    const energySource = qs.parse(location.search).energySource;
    dispatch({
      type: INITIALIZE,
      payload: {
        id: id,
        plateNumber: plateNumber,
        vehicleType: vehicleType,
        energySource: energySource ?? FUEL_TYPE.key,
      },
    });
  }, []); // eslint-disable-line

  const onFocus = () => amplitude.plateNumber_edit_plate_onClick();

  const onTextChanged = text => {
    dispatch({ type: CHANGE_PLATE_NUMBER, payload: text });
  };

  const onTypeChanged = type => {
    amplitude.plateNumber_edit_type_onClick();
    dispatch({ type: CHANGE_CAR_TYPE, payload: type });
  };

  const onEnergySourceChange = type => {
      dispatch({ type: CHANGE_ENERGY_SOURCE_TYPE, payload: type });
    };

  const onSubmit = () => {
    amplitude.plateNumber_edit_complete_onClick();
    updateLicensePlate({ payload: state });
  };

  return (
    <EditLicensePlateLayout
      plateNumber={state.plateNumber}
      vehicleType={state.vehicleType}
      energySource={state.energySource}
      onEnergySourceChange={onEnergySourceChange}
      onTextChanged={onTextChanged}
      errorMessage={state.plateNumberErrorMessage}
      onRadioClick={onTypeChanged}
      onClick={onSubmit}
      onFocus={onFocus}
      btnLoading={state.loading}
      type="edit"
      rentalPlateDialogShow={state.showRentalPlateDialog}
      rentalPlateDialogOnClick={redirectAfterEditPlate}
    />
  );
};

export default EditLicensePlate;
